import magnifiAPIInstance from "./apiInstance";

export const keyManagementAPIs = {
  generatePartnerAccessKey: ({ payload }) => magnifiAPIInstance.post(`/partner/access-key/generate`, payload),
  removePartnerAccessKey: ({ payload }) => magnifiAPIInstance.delete(`/partner/access-key/remove`, payload),
  listPartnerAccessKeys: ({ entityId }) => magnifiAPIInstance.get(`/partner/access-key/${entityId}/list`),
  renamePartnerAccessKey: ({ payload }) => magnifiAPIInstance.post(`/partner/access-key/rename`, payload),
};
